import { createContext, useContext } from "react";

export const ReactAppState = createContext();
ReactAppState.displayName = 'ReactMLS';

export function useReactAppState() {
  const context = useContext(ReactAppState);
  if (context === undefined) {
    throw new Error('useAppState must be used within a <App />');
  }
  return context;
}
